//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  angular.module('curalate').service('InstagramAccountsService', [
    '$log',
    'INSTAGRAM_ACCOUNTS_ACTIONS',
    'InstagramSettingsService',
    'rx',
    function(
            $log,
            INSTAGRAM_ACCOUNTS_ACTIONS,
            InstagramSettingsService,
            rx,
        ) {
      const initialState = {};

      const updates = new rx.ReplaySubject(1);
      const instagramAccountsState = updates.scan((state, action) => {
        const newState = angular.copy(state);
        switch (action.type) {
          case INSTAGRAM_ACCOUNTS_ACTIONS.REFRESH_INSTAGRAM_ACCOUNTS: {
            const accounts = action.instagramSettings.accounts;
            const primaryAccountId = action.instagramSettings.primaryAccountId;
            newState.defaultInstagramAccount = _(accounts).findWhere({ accountId: primaryAccountId });
            break;
          }
          default:
            $log.error(`unrecognized action type: ${action.type}`);
            break;
        }
        return newState;
      }, initialState);

      this.getInstagramAccountsState = function() {
        return instagramAccountsState.asObservable();
      };

      this.refresh = function() {
        rx.Observable.fromPromise(InstagramSettingsService.getInstagramSettings()).subscribe((response) => {
          updates.next({
            type: INSTAGRAM_ACCOUNTS_ACTIONS.REFRESH_INSTAGRAM_ACCOUNTS,
            instagramSettings: response,
          });
        });
      };

            // initialize the service
      this.refresh();
    },
  ]);
})();
